import { ConversionInfo } from './../../models/Coin';
import { StreamPriceMap, StreamPrice, StreamSubscription } from './../../models/Socket';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import * as SocketIO from 'socket.io-client';

declare var CCC: any;
/*
  Generated class for the CccSocketProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class CccSocketProvider {
  SATOSHI_MULTIPLIER: number = 100000000;
  streamPriceMap: StreamPriceMap = {};
  socket: SocketIOClient.Socket;
  constructor(public http: HttpClient) {
    let instance = this;
    this.socket = SocketIO.connect('https://streamer.cryptocompare.com/');
    this.socket.on("m", function(message) {
      var messageType = message.substring(0, message.indexOf("~"));
      if (messageType == CCC.STATIC.TYPE.CURRENTAGG || messageType == CCC.STATIC.TYPE.CURRENT) {
        instance.unpack(message);
      }
    });
  }

  public subscribe(pairs: StreamSubscription[]){
    let subStrings = [];
    for(let pair of pairs){
      subStrings.push(this.getSubString(pair));
    }
    this.socket.emit('SubAdd', { subs: subStrings });
  }

  public unSubscribe(pairs: StreamSubscription[]){
    let subStrings = [];
    for(let pair of pairs){
      subStrings.push(this.getSubString(pair));
    }
    this.socket.emit('SubRemove', { subs: subStrings });
  }

  public getStreamSubscription(market: string, from: string, to: string): StreamSubscription{
    let sub: StreamSubscription = {
      market: market,
      from: from,
      to: to
    }
    return sub;
  }

  private getSubString(sub: StreamSubscription): string{
    let feedType = '2'; //for regular markets
    if(sub.market == 'CCCAGG') feedType = '5';
    return `${feedType}~${sub.market}~${sub.from}~${sub.to}`;
  }

  public getPriceOld(market: string, from: string, to: string): StreamPrice{
    let pair = `${from}${to}`

    if(!this.streamPriceMap.hasOwnProperty(pair)) {
      return null;
    }

    if(!this.streamPriceMap[pair].hasOwnProperty(market)){
      return null;
    }

    return this.streamPriceMap[pair][market];

  }

  public getPrice(sub: StreamSubscription): StreamPrice{
    if(!sub) return null;

    let pair = `${sub.from}${sub.to}`

    if(!this.streamPriceMap.hasOwnProperty(pair)) {
      return null;
    }

    if(!this.streamPriceMap[pair].hasOwnProperty(sub.market)){
      return null;
    }

    return this.streamPriceMap[pair][sub.market];

  }

  private unpack(message) {
		var data = CCC.CURRENT.unpack(message);

		var from = data['FROMSYMBOL'];
		var to = data['TOSYMBOL'];
		var fsym = CCC.STATIC.CURRENCY.getSymbol(from);
		var tsym = CCC.STATIC.CURRENCY.getSymbol(to);
    var pair = from + to;
    var market = data['MARKET'];
		if (!this.streamPriceMap.hasOwnProperty(pair)) {
      this.streamPriceMap[pair] = {};
    }

    if(!this.streamPriceMap[pair].hasOwnProperty(market)){
      this.streamPriceMap[pair][market] = {};
    }

		for (var key in data) {
			this.streamPriceMap[pair][market][key] = data[key];
		}

		if (this.streamPriceMap[pair][market]['LASTTRADEID']) {
			this.streamPriceMap[pair][market]['LASTTRADEID'] = parseInt(this.streamPriceMap[pair][market]['LASTTRADEID']).toFixed(0);
		}
		this.streamPriceMap[pair][market]['CHANGE24HOUR'] = CCC.convertValueToDisplay(tsym, (this.streamPriceMap[pair][market]['PRICE'] - this.streamPriceMap[pair][market]['OPEN24HOUR']));
		this.streamPriceMap[pair][market]['CHANGE24HOURPCT'] = ((this.streamPriceMap[pair][market]['PRICE'] - this.streamPriceMap[pair][market]['OPEN24HOUR']) / this.streamPriceMap[pair][market]['OPEN24HOUR'] * 100).toFixed(2) + "%";
  };

  public getSubFromConversion(conversion: ConversionInfo){
    return this.getStreamSubscription(conversion.Market, conversion.CurrencyFrom, conversion.CurrencyTo);
  }
}



// WEBPACK FOOTER //
// ./src/providers/ccc-socket/ccc-socket.ts